import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import Header from 'src/features/navigation/Header';
import Sidebar from 'src/features/navigation/Sidebar';

function HomeLayout() {
    return (
        <div className="grid min-h-screen max-w-full grid-cols-[1fr_minmax(0,8fr)] p-2">
            <Sidebar />
            <MainLayout className={'min-w-0 pl-8'}>
                <Header />
                <div className="overflow-x-auto">
                    <Outlet />
                </div>
            </MainLayout>
        </div>
    );
}

export default HomeLayout;
